// Constants + pure helpers for the Document Templates page.

export const DOC_TYPE_LABELS = {
  terms_and_conditions: 'Terms & Conditions',
  credit_agreement: 'Credit Agreement',
};

export const DOC_TYPE_OPTIONS = [
  { value: 'terms_and_conditions', label: 'Terms & Conditions' },
  { value: 'credit_agreement', label: 'Credit Agreement' },
  { value: 'policy', label: 'Policy' },
  { value: 'disclosure', label: 'Disclosure' },
  { value: 'custom', label: 'Custom' },
];

export const EXPIRY_OPTIONS = [
  { value: 'none', label: 'No expiration' },
  { value: '30', label: '30 days' },
  { value: '90', label: '90 days' },
  { value: '180', label: '6 months' },
  { value: '365', label: '1 year' },
];

export const formatExpiry = (days) => {
  if (!days) return 'No expiration';
  if (days === 365) return '1 year';
  if (days === 180) return '6 months';
  if (days === 90) return '90 days';
  if (days === 30) return '30 days';
  return `${days} days`;
};
